export const version = '2.47.12';
//# sourceMappingURL=version.js.map